import { render, staticRenderFns } from "./ItemsButton.vue?vue&type=template&id=487e2d48&"
import script from "./ItemsButton.vue?vue&type=script&lang=js&"
export * from "./ItemsButton.vue?vue&type=script&lang=js&"
import style0 from "./ItemsButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports